import { useContext } from "react";
import { FormBuilderContext } from "../FormBuilderContext";
import "./AddActionWrapper.less";

const AddActionWrapper = ({ children }) => {
   const { previewMode } = useContext(FormBuilderContext);

   return !previewMode ? (
      <div className="form-builder-add-action">
         <div className="form-builder-add-action-btn">{children}</div>
      </div>
   ) : null;
};

export default AddActionWrapper;
